import React from "react";
import Page from "../components/layout/Page";

//@ts-ignore
import img1 from "../assets/images/pages/10.jpg";
//@ts-ignore
import img2 from "../assets/images/pages/11.jpg";

export default function Despre() {
  return (
    <Page>
      <div className="page-title">
        <h1>Despre Noi</h1>
      </div>
      <div className="an-section">
        <div className="an-content">
          <p>
            Cu o experiență de peste 20 de ani în domeniul instalațiilor
            electrice și al automatizărilor, suntem o firmă specializată în
            proiectarea și implementarea sistemelor de automatizare pentru case
            inteligente. Ca partener oficial Loxone în Cluj-Napoca, oferim
            soluții complete pentru a crește confortul, siguranța și eficiența
            energetică a locuinței tale.
          </p>
        </div>
      </div>
      <div className="an-section bg-1">
        <div className="an-content flex align-center">
          <div className="an-col w-6">
            <h2>Obiectivul nostru:</h2>
            <p className="mb-0">
              Obiectivul nostru principal este să livrăm sisteme de automatizare
              care funcționează impecabil. Punem accent pe crearea unor locuințe
              cu adevărat inteligente, unde tehnologia operează autonom pentru a
              simplifica activitățile zilnice și a optimiza consumul de resurse,
              fără a avea nevoie de o interacțiune complexă din partea ta.
            </p>
          </div>
          <div className="an-col w-6">
            <img src={img1} className="max-400 center"></img>
          </div>
        </div>
      </div>
      <div className="an-section">
        <div className="an-content align-center flex">
          <div className="an-col w-6 order-2-mobile">
            <img src={img2} className="max-400 center"></img>
            <a className="btn btn-primary show-on-mobile" href="/#contact">
              Programează o vizită în Showroom!
            </a>
          </div>
          <div className="an-col w-6 order-1-mobile">
            <h2>Echipa de specialiști:</h2>
            <p>
              Echipa noastră este compusă din ingineri cu experiență solidă în
              domeniul sistemelor electrice și al automatizarilor. Investim
              constant în pregătirea profesională pentru a fi la curent cu cele
              mai recente inovații tehnologice și pentru a vă oferi cele mai
              bune soluții de pe piață.
            </p>
            <p>
              Cea mai bună metodă de a înțelege funcționalitățile și beneficiile
              unui sistem loxone este să îl testezi. Te așteptăm în ModelHome-ul
              nostru din Cluj-Napoca pentru o prezentare detaliată și pentru a
              discuta despre cum putem aplica această tehnologie în proiectul
              tău.
            </p>
            <a className="btn btn-primary hide-on-mobile" href="/#contact">
              Programează o vizită în Showroom!
            </a>
          </div>
        </div>
      </div>
    </Page>
  );
}
